import type { Theme } from '@mui/material/styles/createTheme';
import type { TFunction } from 'i18next';
import type { SaleEventProps } from '../useSaleEvent';
import { KTS_SUB_ID } from '../../../../constants';

export const getEarlyBirdSaleEvent = (_theme: Theme, t: TFunction): SaleEventProps => ({
  name: 'Early Bird',
  discountData: {
    discount: 50,
    discountedSubscriptions: [KTS_SUB_ID.MONTHLY, KTS_SUB_ID.YEARLY],
    code: 'EARLYBIRD',
  },
  title: t('home.pricing.special_event_title_kts'),
  subtitle: t('home.pricing.special_event_subtitle_kts'),
  borderText: t('home.pricing.special_event_border_text_kts'),
  navigationText: t('home.pricing.special_event_navigation_kts'),
  styles: {
    title: {
      fontFamily: 'DynaPuff',
      color: '#0ef7ff',
      fontWeight: 600,
      fontSize: '3rem',
      marginBottom: 0,
    },
    subtitle: {
      fontFamily: 'DynaPuff',
      fontSize: '1.1rem',
      fontWeight: 400,
      textAlign: 'center',
    },
    card: {
      boxShadow: `0px 0px 10px 10px #0ef7ff`,
    },
    button: {
      fontFamily: 'DynaPuff',
    },
    radioContainer: {
      border: `2px solid #0ef7ff`,
      margin: '10px 0',
    },
    radioBorderText: {
      fontSize: '.8rem',
      fontWeight: 600,
      fontFamily: 'DynaPuff',
      color: '#0ef7ff',
      backgroundColor: '#303031',
    },
    price: {
      color: '#0ef7ff',
      fontFamily: 'DynaPuff',
    },
    bestValue: {
      color: '#0ef7ff',
    },
    navigationButton: {
      background: '#0ef7ff',
      color: 'black',
    },
  },
});
